import React from 'react'

const SVG = ({
  style = {},
  fill = '#5F5F5F',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 34 20'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`svg-icon ${className || ''}`}
  >
    <g transform='translate(-357.758 -648.794)'>
      <g transform='translate(366.998 648.794)'>
        <g transform='translate(0 10.171)'>
          <path
            fill={fill}
            d='M8.8,1.6c1.4,0,2.7,0.6,3.6,1.5c1,1,1.5,2.3,1.5,3.7l0,1.2C12.7,8,9.5,8.2,7.5,8.2
					C5.6,8.2,2.7,8,1.6,7.9V6.8c0-1.4,0.5-2.7,1.5-3.7c1-1,2.3-1.5,3.6-1.5L8.8,1.6 M8.8,0H6.7C4.9,0,3.2,0.7,2,2C0.7,3.3,0,5,0,6.8
					v1.7c0,0.6,0.5,1,1,1l0,0c0,0,4,0.3,6.5,0.3s7-0.3,7-0.3c0.6,0,1-0.5,1-1l0-1.7c0-1.8-0.7-3.5-2-4.8C12.3,0.7,10.6,0,8.8,0
					L8.8,0z'
          />
        </g>
        <g transform='translate(3.104)'>
          <path
            fill={fill}
            d='M4.7,1.6c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1S1.6,6.3,1.6,4.7C1.6,3,3,1.6,4.7,1.6
					 M4.7,0C2.1,0,0,2.1,0,4.7s2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C9.3,2.1,7.2,0,4.7,0z'
          />
        </g>
      </g>
      <g id='Group_94' transform='translate(357.758 650.233)'>
        <g id='Group_91' transform='translate(0 8.479)'>
          <path
            fill={fill}
            d='M6.4,8.9c-1.9,0-4.8-0.2-4.9-0.2l0,0C0.7,8.7,0,8,0,7.1V5.9c0-1.5,0.6-3,1.7-4.1
					C2.8,0.6,4.3,0,5.8,0h1.5c0.9,0,1.7,0.2,2.5,0.6c0.4,0.2,0.5,0.7,0.3,1.1C10,2,9.6,2.2,9.2,2C8.6,1.7,8,1.6,7.4,1.6H5.8
					c-1.1,0-2.2,0.5-3,1.3C2,3.7,1.6,4.7,1.6,5.9v1.3c0,0,3,0.2,4.8,0.2c0.3,0,0.7,0,1.1,0l0.3,0h0c0.4,0,0.8,0.3,0.8,0.8
					c0,0.4-0.3,0.8-0.8,0.8l-0.3,0C7.1,8.9,6.7,8.9,6.4,8.9z'
          />
        </g>
        <g id='Group_93' transform='translate(2.742)'>
          <path
            fill={fill}
            d='M4,1.6c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4C2.7,6.4,1.6,5.3,1.6,4S2.7,1.6,4,1.6
					C4,1.6,4,1.6,4,1.6 M4,0C1.8,0,0,1.8,0,4c0,2.2,1.8,4,4,4s4-1.8,4-4c0,0,0,0,0,0C8,1.8,6.2,0,4,0z'
          />
        </g>
      </g>
      <g id='Group_99' transform='translate(381.025 650.233)'>
        <g id='Group_96' transform='translate(0.397 8.479)'>
          <path
            fill={fill}
            d='M3.9,8.9c-0.3,0-0.7,0-1.1,0l-0.3,0c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8l0.3,0
					c0.4,0,0.8,0,1.1,0c1.8,0,4.7-0.2,4.8-0.2l0-1.2c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.3-3-1.3H3C2.3,1.6,1.7,1.7,1.2,2
					c-0.4,0.2-0.9,0-1.1-0.4c-0.2-0.4,0-0.9,0.4-1.1C1.2,0.2,2.1,0,3,0h1.5c1.5,0,3,0.6,4.1,1.7c1.1,1.1,1.7,2.6,1.7,4.1v1.3
					c0,0.9-0.7,1.6-1.6,1.6C8.7,8.7,5.8,8.9,3.9,8.9z'
          />
        </g>

        <path
          fill={fill}
          d='M4,1.6c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4C2.7,6.4,1.6,5.3,1.6,4S2.7,1.6,4,1.6
					C4,1.6,4,1.6,4,1.6 M4,0C1.8,0,0,1.8,0,4c0,2.2,1.8,4,4,4s4-1.8,4-4c0,0,0,0,0,0C8,1.8,6.2,0,4,0z'
        />
      </g>
    </g>
  </svg>
)

export default SVG
